import { Checkbox } from "@/components/ui/checkbox";

export const RefundAgree = ({ checked, onChange, testId = "refund-agree" }) => (
  <label
    data-testid={testId}
    className={`flex cursor-pointer items-start gap-3 rounded-lg border p-3 text-sm leading-relaxed transition-colors ${checked ? "border-[#4A6B5D]/30 bg-[#EAF1EE]" : "border-[#A84A32]/30 bg-[#FBF1EC]"}`}
  >
    <Checkbox
      data-testid={`${testId}-checkbox`}
      checked={checked}
      onCheckedChange={(v) => onChange(v === true)}
      className="mt-0.5"
    />
    <span className="text-[#4A4540]">
      I have read and agree to the{" "}
      <a href="/refunds" target="_blank" rel="noreferrer" data-testid={`${testId}-link`} className="font-semibold text-[#A84A32] underline underline-offset-2">
        Refund Policy
      </a>
      . Change of mind refunds are available within 14 days only if the product hasn't been used, generated or downloaded.
    </span>
  </label>
);
